import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import { getQuery } from '@/components/filter/helpers';
import type { BillingSettingPopulate } from '@enmon/commons/lib/enmon';
import type {
  CreateBillingSettingArgs,
  DeleteBillingSettingArgs,
  GetBillingSettingsArgs,
  GetOneBillingSettingArgs,
  UpdateBillingSettingArgs,
} from './types/args';
import type {
  CreateBillingSettingResult,
  DeleteBillingSettingResult,
  GetBillingSettingsResult,
  GetOneBillingSettingResult,
  UpdateBillingSettingResult,
} from './types/results';

export class BillingSettingsApiClient extends BaseApiClient {
  constructor() {
    super('api/billing-settings');
  }

  public create(payload: CreateBillingSettingArgs): Promise<CreateBillingSettingResult> {
    return this.http.post('', payload);
  }

  public delete(id: DeleteBillingSettingArgs): Promise<DeleteBillingSettingResult> {
    return this.http.delete(`${id}`);
  }

  public get(
    filter: GetBillingSettingsArgs,
    populate: BillingSettingPopulate[] = [],
    signal: RequestOptions['signal'] = undefined,
  ): Promise<GetBillingSettingsResult> {
    return this.http.get('', { query: { ...getQuery(filter), populate: populate?.join(',') }, signal });
  }

  public getOne(
    id: GetOneBillingSettingArgs,
    populate: BillingSettingPopulate,
    signal: RequestOptions['signal'] = undefined,
  ): Promise<GetOneBillingSettingResult> {
    return this.http.get(`${id}`, { query: { populate }, signal });
  }

  public update({ id, payload }: UpdateBillingSettingArgs): Promise<UpdateBillingSettingResult> {
    return this.http.patch(`${id}`, payload);
  }
}
